import { ChangeDetectionStrategy, Component } from '@angular/core';
import { RouterOutlet } from '@angular/router';
import { Toast } from 'primeng/toast';
import { PrdConfirmDialog } from './shared/prd-confirm/prd-confirm-dialog';

// App root: hosts the router outlet plus the global overlays (toast +
// the shared prd typed-confirmation dialog). The authenticated shell is a
// routed layout, so the outlet renders either sign-in or the shell.
@Component({
  selector: 'app-root',
  imports: [RouterOutlet, Toast, PrdConfirmDialog],
  changeDetection: ChangeDetectionStrategy.OnPush,
  templateUrl: './app.html',
  styleUrl: './app.scss',
})
export class App {}
